import { createContext, useContext } from "react";

interface ThemeContextValue {
  toggleColorMode: () => void;
  mode: "light" | "dark";
}

export const ThemeContext = createContext<ThemeContextValue>({
  toggleColorMode: () => {
    /* default noop */
  },
  mode: "light",
});

export const useThemeMode = () => useContext(ThemeContext);
